// src/overlayComponents/ModuleHeader.js
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';

const ModuleHeader = ({ title }) => {
  const { theme } = useTheme();
  
  return (
    <h4 className={`p-1 border-b ${theme.header} font-medium text-center w-full truncate`}>
      {title}
    </h4>
  );
};

export default ModuleHeader;